import utils from 'components/utilsComponent';
import ModalDialog from 'components/modal-dialog.dev';
import { ajaxGetData } from 'methods/ajaxData';
import HotelRecalls from 'hotels/src/js/components/hotel-recalls';

new ModalDialog({getSession: true});

ajaxGetData().then((r) => {
    // модалки
    if (r.modals && r.modals.length > 0) {
        let $div = document.createElement('div');
            $div.innerHTML = r.modals;

        let $support = $div.querySelector('.Support');
        if ($support) {
            $support.remove();
        }

        document.body.appendChild($div);
    }

    [
        () => {new HotelRecalls()},
    ].forEach(fn => {
        try {
            fn();
        } catch(e) {
            utils.error(e);
        }
    });
});

// Липкие элеметы
utils.stickInParent(document.querySelector('.Sticky-block'), 80);

document.addEventListener('click', function(event) {
    const canUseClosest = !!event.target.closest;

    /**
     * Скрываем большие отзывы и добавляем кнопку "Показать полностью"
     */
    if (canUseClosest && event.target.closest('.js-openBlock')) {
        const $button = event.target.closest('.js-openBlock');

        if ($button.classList.contains('is-active')) {
            $button.classList.remove('is-active');
            $button.textContent = 'Показать полностью';
            $button.closest('li').querySelector('.js-heightText').classList.remove('is-open');
            $button.parentElement.classList.remove('is-open');
        } else {
            $button.classList.add('is-active');
            $button.textContent = 'Скрыть';
            $button.closest('li').querySelector('.js-heightText').classList.add('is-open');
            $button.parentElement.classList.add('is-open');
        }
    }

    /**
     * Подгрузка списка отзывов
     */
    if (canUseClosest && event.target.closest('.js-addRecalls')) {
        event.stopPropagation();
        event.preventDefault();
    
        // блокируем кнопку
        const $button = event.target.closest('.js-addRecalls');
        if ($button.classList.contains('is-opening')) {
            return false;
        }
        $button.classList.add('is-opening');
        $button.setAttribute('disabled', 'disabled');
    
        // инициируем AJAX-подгрузку
        fetch(window.location.pathname.replace('recalls/', 'hotel_recalls/'), {
            method: 'POST',
            cache: 'no-store', // Дополнительно указываем политику кэширования
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
            body: {
                'page_type': 'recalls',
                'exclude_ids': [...document.querySelectorAll('.js-recallList li')].map($item => $item.dataset.id),
            }
        })
        .then(response => response.json())
        .then(response => {
            if (response.status !== 'ok') {
                return;
            }

            // удаляем кнопку
            if (!response.data.can_more_loaded) {
                $button.remove();
            }

            // добавляем контент
            const $items = document.querySelector('.js-recallList');
            if ($items) {
                $items.insertAdjacentHTML('beforeend', response.data.render);
            }

            $button.classList.remove('is-opening');
            $button.removeAttribute('disabled');

            initHeightText();
        });
    }
});

function initHeightText() {
    document.querySelectorAll('.js-heightText').forEach($text => {
        const heightBlockText = $text.querySelector('p').offsetHeight;
        if ($text.classList.contains('resize-init')) {
            return;
        }

        $text.classList.add('resize-init');

        if (heightBlockText > 147 && !$text.classList.contains('is-open')) {
            $text.classList.remove('is-open');
            $text.insertAdjacentHTML('afterend',
                '<div class="show js-openBlockWrapper"><a href="javascript:void(0);" class="link js-openBlock">Показать полностью</a></div>'
            );
        } else if (heightBlockText <= 147) {
            $text.classList.add('is-open');

            let $openBlockWrapper = $text.closest('li').querySelector('.js-openBlockWrapper');
            if ($openBlockWrapper) {
                $openBlockWrapper.remove();
            }
        }
    });
}

initHeightText();